<template>
  <div>
    <v-alert v-if="catatanVerval" border="left" colored-border color="red" class="bg-error" icon="mdi-alert">
      <p class="black--text mb-0">
        <strong>Hai {{ $getDeepObj(pa, 'ptk.nama') }}!</strong> Ajuan yang telah Anda lakukan sebelumnya memerlukan
        perbaikan sebagaimana catatan berikut:
      </p>
      <v-divider class="my-2" />
      <em>{{ catatanVerval }}</em>
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">Profil Fasilitator</h1>
            <div class="body-2 black--text mb-3">
              Anda memiliki peran sebagai <strong>Fasilitator</strong> Program Sekolah Penggerak. Silakan melengkapi
              profil Anda sesuai data terkini.
            </div>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left body-2 font-weight-bold px-0">
                      <v-row no-gutters class="py-1">
                        <v-col cols="12" md="8">Indikator Kelengkapan Data</v-col>
                        <v-col class="d-none d-sm-flex" cols="12" md="4">Status/Pemenuhan</v-col>
                      </v-row>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(indikator, i) in indikators" :key="i">
                    <td class="px-0">
                      <v-row no-gutters class="py-2">
                        <v-col cols="10" md="8">
                          {{ indikator.label }}
                        </v-col>
                        <v-col cols="2" md="4">
                          <v-icon :color="indikator.value ? 'success' : 'grey'">
                            {{ indikator.value ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                          </v-icon>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="mt-3 grey lighten-4 black--text pa-2" style="font-size: 0.8rem; border-radius: 5px">
              <b>Keterangan Status :</b>
              <div>
                <v-icon small left color="success" style="margin-bottom: 3px" class="mr-1">mdi-check-circle</v-icon>
                Data sudah dilengkapi
              </div>
              <div>
                <v-icon small left color="grey" style="margin-bottom: 3px" class="mr-1">mdi-alert-circle</v-icon>
                Data Belum dilengkapi
              </div>
            </div>
            <template v-if="$isObject(biodata)">
              <div v-if="biodata.k_verval_psp < 2 || biodata.k_verval_psp === 5" class="mt-3">
                <v-btn depressed :disabled="!isLengkap" color="primary" @click="onKirim">
                  Kirim Berkas <v-icon right small>mdi-send</v-icon>
                </v-btn>
              </div>
              <div v-else-if="biodata.k_verval_psp === 6" class="mt-3">
                <v-btn depressed outlined color="green">
                  <v-icon left small>mdi-file-document</v-icon> Berkas Diterima
                </v-btn>
              </div>
              <div v-else>
                <v-alert type="info" text dense class="mt-5 mb-0" v-if="!isKunciAjuan">
                  <p class="black--text mb-0">
                    Berkas sedang dalam tahap verval. Jika Anda ingin mengubah kembali silakan klik
                    <a href="javascript:" @click="onBatalKirim">disini</a>
                  </p>
                </v-alert>
                <v-btn depressed outlined color="info" class="mt-2">
                  <v-icon left small>mdi-file-document</v-icon> Proses Verval
                </v-btn>
              </div>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-alert
      dense
      icon="mdi-information"
      colored-border
      border="left"
      type="info"
      class="yellow lighten-4 no-border"
      color="orange darken-1"
      v-if="!$isObject(biodataEdit) && biodata.k_verval_psp === 1"
    >
      <p class="ma-0 text-justify">
        Anda terdeteksi, belum melengkapi profil fasilitator Anda atau belum mengirimkan profil Fasilitator Anda.
        Silakan lengkapi hingga semua bagian di atas tercentang <span class="font-weight-medium">Hijau,</span> kemudian
        lakukan <span class="font-weight-medium">KIRIM BERKAS.</span> Selanjutnya tunggu proses vervalnya di Admin
        BBGP/BGP naungan Anda
      </p>
    </v-alert>
    <v-alert class="yellow lighten-4" v-else-if="$isObject(biodataEdit) && biodataEdit.k_verval_psp !== 6">
      <p class="ma-0 text-justify">
        Perubahan data yang telah Anda lakukan ditandai dengan tulisan dengan <strong>warna jingga</strong>, dan untuk
        meilihat rekap perubahan data yang telah Anda lakukan silakan klik tombol rekap perubahan di bawah.
      </p>
      <div class="mt-2">
        <v-btn depressed color="orange" class="text-capitalize" dark small @click="onViewRekap">
          <v-icon left>mdi-eye</v-icon> Rekap Perubahan
        </v-btn>
      </div>
    </v-alert>
    <v-expansion-panels tile flat class="mb-5" v-model="tab">
      <v-expansion-panel v-for="indikator in indikators" :key="indikator.key">
        <v-expansion-panel-header class="px-4 subtitle-1">
          <strong>{{ indikator.label }}</strong>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content v-if="$isObject(biodata) && $isObject(biodata)" class="px-0">
          <component
            v-if="$isObject(biodata)"
            :ref="`tab-${indikator.key}`"
            :is="$titleCase(indikator.key)"
            :index="index"
            :edit="edit"
            :biodata="biodata"
            :biodata-edit="biodataEdit"
            :updates="updates"
            :k-verval-psp="kVervalPsp"
            :is-edit-biodata="isEditBiodata"
            :key-biodata-updates="keyBiodataUpdates"
            :key-berkas-updates="keyBerkasUpdates"
            :masters="Object.assign({}, masters, opsi)"
            @reload="reload"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <popup-rekap
      v-if="$isObject(biodata)"
      ref="rekap"
      :edit="edit"
      :biodata="edit.biodata || {}"
      :biodata-edit="edit.biodata_baru || {}"
      :key-biodata-updates="keyBiodataUpdates"
      :key-berkas-updates="keyBerkasUpdates"
      @approve="onApproveAction"
    />
  </div>
</template>

<script>
import Administrasi from './components/Administrasi';
import Instansi from './components/Instansi';
import Biodata from './components/Biodata';
import Penugasan from './components/Penugasan';
import Dokumen from './components/Dokumen';
import PopupRekap from './popup/Rekap';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'fsp',
  components: { Administrasi, Instansi, Biodata, Penugasan, Dokumen, PopupRekap },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    ...mapState('preferensi', {
      instruktur: (state) => state.data?.instruktur ?? {},
      pa: (state) => state.data?.pelatih_ahli ?? {},
      aksesEdit: (state) => state.menu?.biodata_edit ?? false,
    }),

    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('biodata', {
      index: (state) => (state && state.index) || {},
      edit: (state) => (state && state.edit) || {},
      biodata: (state) => (state && state.index && state.index.biodata) || {},
      opsi: (state) => state?.opsi ?? {},
    }),

    isKunciAjuan() {
      const pspProfilProses = this.biodata.psp_profil_proseses || [];

      if (this.$isObject(this.biodataEdit)) {
        return this.biodataEdit.k_verval_psp === 3;
      }

      return (
        !this.$isObject(this.edit) && pspProfilProses.filter((proses) => +proses.k_profil_proses_psp === 25).length
      );
    },

    biodata() {
      if (this.$isObject(this.edit)) {
        return this.edit.biodata_baru || {};
      }

      return this.index.biodata || {};
    },

    biodataEdit() {
      return this.edit.biodata_edit || {};
    },

    kVervalPsp() {
      return this.biodata.k_verval_psp || '';
    },

    isEditBiodata() {
      if (this.$isObject(this.edit)) {
        return this.biodata.k_verval_psp !== 2;
      }

      return !this.kVervalPsp || [1, 5].includes(this.kVervalPsp);
    },

    updates() {
      let pspBiodataEditDatas = [];

      if (this.biodataEdit.k_verval_psp !== 6) {
        pspBiodataEditDatas = this.biodataEdit.psp_biodata_edit_datas || [];
      }

      return {
        biodata: pspBiodataEditDatas.filter((update) => update.model_type === 'Modules\\Psp\\Models\\PspBiodata'),
        tugas: pspBiodataEditDatas.filter((update) => update.model_type === 'Modules\\Psp\\Models\\PspBiodataTugas'),
        berkas: pspBiodataEditDatas.filter((update) => update.model_type === 'Modules\\Psp\\Models\\PspBiodataBerkas'),
      };
    },

    keyBiodataUpdates() {
      let result = [];

      for (const biodata of this.updates.biodata || []) {
        const keys = Object.keys(biodata.final) || [];

        result = [...result, ...keys];
      }

      return result;
    },

    keyBerkasUpdates() {
      return (this.updates.berkas || []).map((update) => +update.model_id);
    },

    indikators() {
      const lengkap = this.edit.status_lengkap || this.index.status_lengkap || {};

      return [
        { label: 'Biodata Diri', key: 'biodata', value: lengkap.biodata },
        { label: 'Data Instansi', key: 'instansi', value: lengkap.instansi },
        { label: 'Referensi Penugasan FSP', key: 'penugasan', value: lengkap.tugas },
        { label: 'Data Pendukung Administrasi', key: 'administrasi', value: lengkap.administrasi },
        { label: 'Dokumen Pendukung', key: 'dokumen', value: lengkap.berkas },
      ];
    },

    isLengkap() {
      const values = Object.values(this.indikators);
      return values.filter((indikator) => indikator.value).length === values.length;
    },

    profilID() {
      return this.instruktur.psp_profil_id || this.pa.psp_profil_id || '';
    },

    catatanVerval() {
      if (this.$isObject(this.biodataEdit) && this.biodataEdit.k_verval_psp === 5) {
        return this.biodataEdit.catatan || '';
      }

      const pspProfilProseses = this.$getDeepObj(this.biodata, 'psp_profil_proseses') || [];
      const pspProfilProses = pspProfilProseses.filter((proses) => +proses.k_profil_proses_psp === 26);
      let catatan = '';

      if (pspProfilProses[0] && pspProfilProses[0]['catatan'] && this.biodata.k_verval_psp === 5) {
        catatan = pspProfilProses[0] && pspProfilProses[0]['catatan'];
      }

      return catatan;
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('biodata', ['fetch', 'fetchEdit', 'option', 'actions']),

    getDetail() {
      this.getMasters(['propinsi', 'kota', 'kualifikasi', 'golongan', 'unsur_psp', 'bank'].join(';')).then(() => {
        this.option(this.profilID).then(() => {
          this[this.aksesEdit ? 'fetchEdit' : 'fetch']();
        });
      });
    },

    reload() {
      this[this.aksesEdit ? 'fetchEdit' : 'fetch']({ reset: true });
    },

    onKirim() {
      if (this.$isObject(this.biodataEdit)) {
        this.$refs.rekap.open('konfirmasi');
        return;
      }

      const message = [
        '<div class="black--text">',
        '<h3 class="subtitle-1 font-weight-medium">Anda sudah melengkapi semua informasi detail profil</h3>',
        '<p class="body-2">Jika Anda sudah merasa yakin semua informasi yang dimasukkan sudah benar, silahkan melakukan kirim berkas melalui tombol berikut</p>',
        '</div>',
      ].join('');

      this.$confirm(message, `Konfirmasi Kirim Berkas`, {
        tipe: 'orange darken-1 white--text',
        lblConfirmColor: 'orange',
        lblConfirmButton: 'Kirim',
        typeConfirmBgButton: true,
        lblCancelButton: 'Batal',
      }).then(() => {
        this.actions({ action: 'ajuan' }).then(() => {
          this.$success('Berhasil dikirim');
          this.reload();
        });
      });
    },

    onBatalKirim() {
      const message = [
        '<div class="black--text">',
        '<h3 class="subtitle-1 font-weight-medium">Apakah Anda yakin ingin membatalkan kirim berkas?</h3>',
        '<p class="body-2">Proses verifikasi data akan dibatalkan jika melakukan batal kirim.</p>',
        '</div>',
      ].join('');

      this.$confirm(message, `Konfirmasi Batal Kirim Berkas`, {
        tipe: 'orange darken-1 white--text',
        lblConfirmColor: 'orange',
        lblConfirmButton: 'Ya',
        typeConfirmBgButton: true,
        lblCancelButton: 'Batal',
      }).then(() => {
        this.actions({ update: this.$isObject(this.biodataEdit), action: 'batal-ajuan' }).then(() => {
          this.$success('Berhasil dibatalkan');
          this.reload();
        });
      });
    },

    onViewRekap() {
      this.$refs.rekap.open();
    },

    onApproveAction(action) {
      switch (action) {
        case 'konfirmasi':
          this.actions({ update: true, action: 'ajuan' }).then(() => {
            this.$refs.rekap.close();
            this.$success('Berhasil dikirimkan');
            this.reload();
          });
          break;
      }
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
